import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    firstSection: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      '& .MuiTypography-h1': {
        margin: '2rem 0 1.5rem',
      },

      '& .MuiTypography-h4': {
        fontWeight: 500,
        color: theme.palette.text.secondary,
      },

      '& > div': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        flex: '1',

        '& .MuiSvgIcon-root': {
          fontSize: 76,
          color: theme.palette.primary.main,
        },
      },
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'flex-end',

      '& button, a': {
        height: 'auto',
        width: 'auto',
        minWidth: '10rem',
        padding: '1rem 1.5rem',
        margin: 0,
      },

      '& > button': {
        color: '#727970',
      },

      '& > div button:first-child': {
        color: theme.palette.primary.dark,
      },
    },
  }),
)
